import {Button, Menu, MenuItem} from "@mui/material";
import React, {useMemo} from "react";
import {TbFilterDown} from "react-icons/tb";

const MenuMapComponent = ({setSelectedRegion, setSelectedVariable}) => {

  const [anchorEl, setAnchorEl] = React.useState()
  const open = Boolean(anchorEl)

  const menuOptions = useMemo(() => ["Município", "Micro-Região", "Macro-Região"], [])

  const menuItems = useMemo(() => {
    const regionNames = {
      "Município": "total",
      "Micro-Região": "valuesMicro",
      "Macro-Região": "valuesMacro",
      "Região de Saúde": "valuesHealthRegion"
    };

    return menuOptions.map((region) => (
        <MenuItem
          onClick={() => {
            setAnchorEl(null)
            if (region !== "") {
              setSelectedRegion(region)
              setSelectedVariable(regionNames[region])
            }
          }}
          key={region}
          value={"Cidade"}>
          {region}
        </MenuItem>
    ))
  }, [ menuOptions, setAnchorEl, setSelectedRegion, setSelectedVariable]
  )

  return (
    <>
      <Button
      onClick={(event) => {setAnchorEl(event.currentTarget)}}
      aria-controls={open ? 'demo-positioned-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
    >
      <TbFilterDown className="mx-2 md:text-3xl text-xl text-emerald-700 hover:text-emerald-800 cursor-pointer"/>
    </Button>
      <Menu
        open={open}
        id="demo-positioned-menu"
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
      >
        {menuItems}
      </Menu>
    </>

  )
}

export default MenuMapComponent